import { object, number, bool, string, array } from '@gogame/schemas';

export const tagsCategorySchema = object({
  id: number(),
  isMultiselect: bool(),
  type: string(),
  name: string().required('Name is required'),
  tags: array().required('Tags field must have at least 1 item'),
});
